import { useEffect } from 'react';
import { LOGIN_CENTRAL_URL } from '../config';

// Almuerzos ahora es una aplicación aparte: se entra por el login central, igual que los demás accesos directos.
export default function AlmuerzosRedireccion() {
  useEffect(() => {
    window.location.replace(`${LOGIN_CENTRAL_URL}/?app=almuerzos`);
  }, []);
  return <p className="p-6 text-sm text-gray-600 dark:text-gray-300">Redirigiendo a la nueva aplicación de Almuerzos…</p>;
}
